import React from "react";

import { Grid } from "@material-ui/core";

import Insight from "./insight/Insight";
import Navigation from "./navigation/Navigation";
import {
    clearInsights,
    clearProduct,
    clearStoreRangeFilters,
    clearOperators,
    loadInsights,
    loadProduct,
    loadStoreFilters,
    loadOperators,
    selectSelectedPartner,
    selectSelectedOperator,
    selectSelectedRange,
    selectSelectedStore
} from "modules/customer/tools/product/productSlice";
import { useAppDispatch, useAppSelector } from "store";
import { showPartnerFilters, selectCandidatePartner } from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";

const Product: React.FC = () => {
    const dispatch = useAppDispatch();
    const candidatePartner = useAppSelector(selectCandidatePartner);
    const partner = useAppSelector(selectSelectedPartner);
    const operator = useAppSelector(selectSelectedOperator);
    const store = useAppSelector(selectSelectedStore);
    const range = useAppSelector(selectSelectedRange);
    const isSetupComplete = !!partner;

    React.useEffect(() => {
        dispatch(loadProduct());
        dispatch(showPartnerFilters());
        return () => {
            dispatch(clearProduct());
        };
    }, [dispatch]);

    // If candidate partner changes, reload load respective operators
    React.useEffect(() => {
        if (candidatePartner) {
            dispatch(loadOperators());
        }
        return () => {
            dispatch(clearOperators());
        };
    }, [dispatch, candidatePartner]);

    // If partner changes, reload insights & modal
    React.useEffect(() => {
        if (partner) {
            dispatch(loadInsights());
            dispatch(loadStoreFilters());
        }
        return () => {
            dispatch(clearInsights());
            dispatch(clearStoreRangeFilters());
        };
    }, [dispatch, partner, operator]);

    // If store changes, reload insights only
    React.useEffect(() => {
        dispatch(loadInsights());
        return () => {
            dispatch(clearInsights());
        };
    }, [dispatch, store, range]);
    return (
        <Grid container data-cy="pages-customer-tools-product">
            <Grid item xs={3}>
                <Navigation isSetupComplete={isSetupComplete} />
            </Grid>
            <Grid item xs={9}>
                <Insight isSetupComplete={isSetupComplete} />
            </Grid>
        </Grid>
    );
};

export default Product;
